import PropTypes from 'prop-types'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getIsActiveFollowRoute } from '../../../helpers/common'
import { CustomLink } from '../../CustomLink'
import { LockAction } from '../../LockAction'
import { Element } from '../../html/element'
import { Icon } from '../../html/icon'
import { Label } from '../Label'
import { List } from './List'
import classes from './index.module.scss'

export const Item = ({
  route,
  label,
  children,
  isI18n,
  isLock,
  isChildren,
  isTopItem,
  keepQueryStrParams,
}) => {
  const location = useLocation()
  const isActive = getIsActiveFollowRoute(location, route)
  const isActiveChildren = getIsActiveFollowRoute(location, route, children)

  const [isShow, setShow] = useState(true)

  const clickIconCaret = () => {
    setShow((prev) => !prev)
  }

  const renderContent = () => {
    return (
      <LockAction enable={isLock}>
        <div
          className={classes.item}
          style={{ marginLeft: isChildren ? 16 : 0 }}
        >
          <Label label={label} isActive={isActive} isI18n={isI18n} />
          {isLock && (
            <Icon
              className="icon-lock"
              style={{ color: '#9C9C9C', fontSize: 10 }}
            />
          )}
          {children && (
            <Icon
              className="icon-caret-bottom"
              style={{
                color: isActiveChildren ? '#2C73E8' : '#3A414B',
                fontSize: 8,
              }}
              onClick={clickIconCaret}
            />
          )}
        </div>
      </LockAction>
    )
  }

  const getBgColor = () => {
    if (isActive) {
      return '#ECF3FF'
    }

    return isChildren ? '#F3F3F3' : 'transparent'
  }

  return (
    <Element
      elementName="li"
      style={{
        backgroundColor: getBgColor(),
        borderTopWidth: isTopItem && 1,
        borderTopStyle: isTopItem && 'solid',
        borderTopColor: isTopItem && '#E5E5E5',
        borderLeftWidth: isActive && 4,
        borderLeftStyle: isActive && 'solid',
        borderLeftColor: isActive && '#2C73E8',
      }}
    >
      <CustomLink
        to={route}
        inActive={isLock}
        keepQueryStrParams={keepQueryStrParams}
      >
        {renderContent()}
      </CustomLink>
      {children && isShow && <List list={children} isChildren />}
    </Element>
  )
}

Item.propTypes = {
  label: PropTypes.string.isRequired,
  isI18n: PropTypes.bool,
  isLock: PropTypes.bool,
  isChildren: PropTypes.bool,
  isTopItem: PropTypes.bool,
  route: PropTypes.string,
}

Item.defaultProps = {
  isI18n: true,
  isLock: false,
  isChildren: false,
  isTopItem: false,
}
